import { render } from "./JoinGroupWithLink.vue?vue&type=template&id=7a684312&scoped=true&lang=pug"
import script from "./JoinGroupWithLink.vue?vue&type=script&lang=ts"
export * from "./JoinGroupWithLink.vue?vue&type=script&lang=ts"

import "./JoinGroupWithLink.vue?vue&type=style&index=0&id=7a684312&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-7a684312"

export default script